import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ThePinnacleHero from "./sections/ThePinnacleHero";
import TraditionalVsFlavr from "./sections/TraditionalVsFlavr";
import RideCategories from "./sections/RideCategories";
import ModernLearningMetrics from "./sections/ModernLearningMetrics";
import BehindTheMic from "./sections/BehindTheMic";
import ClinicalSuccessStories from "./sections/ClinicalSuccessStories";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ThePinnacleHero />
      <TraditionalVsFlavr />
      <RideCategories />
      <ModernLearningMetrics />
      <BehindTheMic />
      <ClinicalSuccessStories />
      <Footer />
    </div>;
}